<template>
  <div class="tinymce-editor">
    <editor id='tinymces_ifr' v-model="myValue" :init="init" :disabled="disabled" @onClick="onClick"></editor>
  </div>
</template>
<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
import "tinymce/plugins/image"; // 插入上传图片插件
// import 'tinymce/plugins/media'// 插入视频插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/icons/default/icons";
import { uploadToLocal } from "@/api/public";
export default {
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default: "lists image table wordcount",
    },
    maxLength: {
      type: [Number],
      default: 20000,
    },
    // 在toolbar中添加工具栏相应按钮
    toolbar: {
      type: [String, Array],
    default:
        "undo redo | bold italic forecolor backcolor | fontsizeselect |fontselect | image |  alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists  table | removeformat ",
    },
  },
  data() {
    return {
      init: {
        language_url: `/tinymce/langs/zh_CN.js`, // 语言包路径
        language: "zh_CN", //语言
        skin_url: `/tinymce/skins/ui/oxide`, //skin路径
        content_css: `/tinymce/skins/content/default/content.css`,
        height: 300, //编辑器高度
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false, //是否禁用“Powered by TinyMCE”
        menubar: false, //顶部菜单栏显示
        fontsize_formats:
          "8px 10px 12px 14px 16px 18px 20px 24px 28px 36px 40px",
        font_formats:
          "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        images_upload_handler: (blobInfo, success, failure) => {
          let formdata = new FormData();
          formdata.set("file", blobInfo.blob());
          uploadToLocal(formdata)
            .then((res) => {
              if (res.code == 200) {
                success(`${this.uploadUrl}/upload/download?id=${res.data[0]}&openStyle=1`);
              } else {
                failure("error");
              }
            })
            .catch((res) => {
              failure("error");
            });
        },
        setup: (ed) => {
          const vm = this;
          ed.on("keyup", function (e) {
            vm.wordLimit(e);
          });
          ed.on("input", function (e) {
            vm.wordLimit(e);
          });
          ed.on("compositionstart", function () {
            vm.isChinese = false;
          });
          ed.on("compositionend", function () {
            vm.isChinese = true;
          });
        },
      },
      myValue: this.value,
    };
  },
  mounted() {
    tinymce.init({});
  },
  methods: {
    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = "";
    },
    //字数限制
    wordLimit(e) {
      const vm = this;
      let last = "";
      let lastIndex = "";
      let startVal = "";
      let endVal = "";
      if (e.target.innerText.length === this.maxLength) {
        vm.htmlText = e.target.innerHTML;
        //兼容输入法有可能会跳过1000
      } else if (
        !vm.isChinese &&
        e.target.innerText.length === this.maxLength + 1
      ) {
        last = e.target.innerText.substr(e.target.innerText.length - 1, 1);
        lastIndex = e.target.innerHTML.lastIndexOf(last);
        startVal = e.target.innerHTML.substring(0, lastIndex);
        endVal = e.target.innerHTML.substring(
          lastIndex + 1,
          e.target.innerHTML.length
        );
        vm.htmlText = startVal + endVal;
      }
      if (e.target.innerText.length > this.maxLength) {
        e.target.innerHTML = vm.htmlText;
        // var ifra = document.getElementById("tinymces_ifr");
        // this.keepLastIndex(
        //   ifra.contentWindow.document.getElementById("tinymce"),
        //   ifra.contentWindow
        // );
        if (!this.limitNum) {
          this.$message.error("长度限制为" + this.maxLength + "个字符");
          this.limitNum++;
        }
      }
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>
<style>
.tox-tinymce-aux {
  z-index: 5000 !important;
}
</style>